<template>
	<div class="layout-img">
		<slot name="title"></slot>
			<b-row>
			<template v-for="(item, index) in dataList">
				<b-col class="layout-item" :key="index" :cols="cols" :md="md">
					<router-link :to="`/detail/index?mode=${type}&categoryId=${item.categoryId || ''}&id=${item.id}&dornorID=${dornorID}`">
						<div
							class="img-wrap img-hovor"
							:style="{height: height}"
						>
							<img
								width="100%"
								height="100%"
								:src="item.titleImg"
							/>
                            <!-- <img
								width="100%"
								height="100%"
								src="http://www.futureprize.org:8100/uploads/figure/71b30f90-3559-4022-8229-a14b0ccbac80.jpg"
							/> -->
						</div>
                        <div class="bottom-title" style="width: 90%; margin: auto;">
                            <p
                                :style="{
                                     'text-align': position,
                                    color: '#666666',
                                
                                }"
                            >
                                {{ item.title }}
                            </p>
                            <p
                                :style="{
                                    'text-align': position,
                                    color: '#999999',
                                }"
                            >
                                {{ item.ename }}
                            </p>
                        </div>
					</router-link>
				</b-col>
			</template>
		</b-row>
		
	</div>
</template>
<script>
export default {
	props: {
		dornorID:{
			type: [Number, String],
			default: ''
		},
		type:{
			type: String,
			default: 'activity'
		},
		position: {
			type: String,
			default: 'center',
		},
		height: {
			type: String,
			default: '14.2rem',
		},
		md: Number,
		cols: Number,
		dataList: {
			type: Array,
			default: () => [
				{
					name: '获奖人',
					ename: 'huojiangren',
					type: '生命科学奖',
					year: 2021,
					firstName: 'A',
				},
				{
					name: '获奖人',
					ename: 'huojiangren',
					type: '生命科学奖',
					year: 2021,
					firstName: 'A',
				},
				{
					name: '获奖人',
					ename: 'huojiangren',
					type: '生命科学奖',
					year: 2021,
					firstName: 'A',
				},
			],
		},
	},
	data() {
		return {}
	},
	watch: {
		dataList(val) {},
	},
	methods: {},
}
</script>
<style lang="scss" scoped>
.layout-img ::v-deep {
	.img-wrap {
        width: 90%;
		margin: 1rem auto;
		img:hover {
			transform: scale(1.05, 1.05);
			transition: transform 0.8s cubic-bezier(0.215, 0.61, 0.355, 1),
			opacity 0.36s cubic-bezier(0.215, 0.61, 0.355, 1);
		}
	}
	a {
		text-decoration: none;
		cursor: pointer;
	}
	.title{
		font-size: 1.5rem;
	}
}
@media (max-width:768px) {
	.layout-img ::v-deep {
        .img-wrap {
            width: 86%;
            height: 18rem;
        }
        p{
            padding-left: 2rem;
        }
    }
}
</style>
